import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { clsx } from 'clsx';
import { WarningPopover } from 'src/components/WarningPopower/WarningPopover';

export const MenuItem = ({
  text,
  icon,
  navigateTo,
  disabled = false,
  isActive = false,
  menuItemClassName = '',
  onClose = () => {},
  isPermissionAccess,
  isMenuOpen,
  external = false,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selected, setSelected] = useState(location.pathname === navigateTo);
  const className = clsx('menu-item', selected && 'selected', disabled && 'disabled');

  useEffect(() => {
    if (isActive) {
      setSelected(true);
    } else {
      setSelected(location.pathname.includes(navigateTo));
    }
  }, [isActive, location.pathname, navigateTo]);

  const handleClick = () => {
    const isAvailable = !disabled && navigateTo;

    if (isAvailable) {
      external ? window.open(navigateTo, '_blank') : navigate(navigateTo);
    }

    if (!disabled) {
      onClose();
    }
  };

  return (
    <div className="relative">
      {isPermissionAccess && (
        <WarningPopover
          triggerClassName={'absolute right-1 items-center flex justify-center top-1'}
          textColor="white"
        />
      )}
      <div
        className={clsx(
          className,
          menuItemClassName,
          isPermissionAccess && 'pointer-events-none opacity-40',
        )}
        onClick={handleClick}
      >
        <div className="flex items-center gap-1 menu-item-wrapper">
          <div className={'menu-item-icon p-2'}>{icon}</div>
          <div
            className={clsx(
              isMenuOpen ? 'opacity-100' : 'opacity-0',
              'menu-item-text transition-all absolute left-10 text-nowrap duration-300',
            )}
          >
            <p>{text}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
